import React, { useEffect } from 'react';
import './style.css';
import SEO from "../../../components/SEO";

const AboutUs = ({ detectPageChange }) => {

  useEffect(() => {
    detectPageChange(window.location.pathname)

  }, [])

  return (
    <>
    <SEO
            title="About 81Handyman — Local Handyman Services"
            description="Learn about 81Handyman and our mission to connect customers with reliable local handymen for home repair and improvement projects."
            path="/about_us"
     />

    <div className="about-us-container">
      <div className="about-us-header">
        <h1>About Us</h1>
      </div>
      <div className="about-us-content">
        <div className="about-us-section">
          <h2>Our Values</h2>
          <p>At <b>81 Handyman</b>, we believe that every home and business deserves reliable, high-quality handyman services. Founded on the principles of honesty, integrity, and transparency, we are committed to providing solutions that our clients can trust.
          </p>
          <p>Our team of skilled professionals brings years of experience and a dedication to excellence in every project—whether it’s a simple repair, a home improvement task, or a more complex renovation. We don’t just fix problems; we deliver lasting results that make your life easier.
          </p>
          <p> We take pride in our customer-first approach. From the initial call to the completion of the job, we maintain clear communication, treat your space with care, and ensure your satisfaction every step of the way.
          </p>
          <p>At <b>81 Handyman</b>, our values define our culture, guide our services, and shape our commitment to creating a positive experience for every client. We aren’t just in the business of repairs—we’re in the business of building trust, one project at a time.
          </p>   </div>

      </div>
    </div>

    </>
  );
};

export default AboutUs;
